import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { FormControl, Grid, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import InputField from '../../../reusable-component/InputField';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  //   border: '#000',
  boxShadow: 24,
  p: 3.5,
};

export default function AddCustomRuleModal({ open, handleClose, metricList, columnName, handleGenerateRulesForEdit }) {
  const INITIALSTATE = {
    metric: '',
    fieldName: '',
    firstSampleValue: '',
    secondSampleValue: '',
    statement: '',
  };

  const [formField, setFormField] = useState(INITIALSTATE);

  const handleChange = (event, source) => {
    switch (source) {
      case 'metric': {
        setFormField({
          ...formField,
          metric: event.target.value,
        });
        break;
      }
      case 'fieldName': {
        setFormField({
          ...formField,
          fieldName: event.target.value,
        });
        break;
      }
      case 'firstSampleValue': {
        setFormField({
          ...formField,
          firstSampleValue: event.target.value,
        });
        break;
      }
      case 'secondSampleValue': {
        setFormField({
          ...formField,
          secondSampleValue: event.target.value,
        });
        break;
      }
      case 'statement': {
        setFormField({
          ...formField,
          statement: event.target.value,
        });
        break;
      }
      default:
        break;
    }
  };

  const handleCancel = () => {
    setFormField(INITIALSTATE);
    handleClose();
  };

  const handleAddCustomRule = async () => {
    const data = {
      metric: formField.metric,
      fieldName: formField.fieldName,
      statement: formField.statement,
      fieldValues: [formField.firstSampleValue, formField.secondSampleValue],
    };

    handleClose();

    await handleGenerateRulesForEdit(data, true, false);
  };

  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Box>
            <Typography variant="p" component="p" sx={{ fontWeight: '550', textTransform: 'uppercase' }}>
              CUSTOM RULE MODAL
            </Typography>
          </Box>
          <Grid container spacing={2} mt={0}>
            <Grid item xs={6}>
              <FormControl size="small" sx={{ width: '100%' }}>
                <InputLabel>Metric</InputLabel>
                <Select
                  id="demo-simple-select-helper"
                  name="metric"
                  size="small"
                  label="Metric"
                  value={formField.metric}
                  onChange={(e) => handleChange(e, 'metric')}
                  // key={data.id}
                  // disabled={disableForm}
                  sx={{ background: '#ffffff' }}
                >
                  {metricList
                    ?.sort((a, b) => a.metric_type?.localeCompare(b.metric_type))
                    ?.map((item) => (
                      <MenuItem key={item.rm_id} value={item.metric_type}>
                        {item.metric_type}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl size="small" sx={{ width: '100%' }}>
                <InputLabel>Column Name</InputLabel>
                <Select
                  id="demo-simple-select-helper"
                  value={formField.fieldName}
                  onChange={(e) => handleChange(e, 'fieldName')}
                  size="small"
                  label="Column Name"
                  name="fieldName"
                  sx={{ background: '#ffffff' }}
                  //   disabled={disableForm}
                >
                  {columnName.map((item) => (
                    <MenuItem key={item.id} value={item.label}>
                      {item.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <InputField
                name="sampleValue1"
                label="Sample Value 1"
                value={formField.firstSampleValue}
                onChange={(e) => handleChange(e, 'firstSampleValue')}
                size="small"
                // disabled={disableForm || !isItemSelected}
                // required={isItemSelected}
                // hidden={!isItemSelected}
              />
            </Grid>
            <Grid item xs={6}>
              <InputField
                name="sampleValue2"
                label="Sample Value 2"
                value={formField.secondSampleValue}
                onChange={(e) => handleChange(e, 'secondSampleValue')}
                size="small"
                // required={isItemSelected}
              />
            </Grid>
          </Grid>
          <Grid container mt={2}>
            <Grid item xs={12}>
              <TextField
                variant="outlined"
                size="small"
                name="statement"
                label="Statement"
                value={formField.statement}
                sx={{ width: '100%', flexGrow: 1 }}
                onChange={(e) => handleChange(e, 'statement')}
                // disabled={dqRule?.isDisabled}
              />
            </Grid>
          </Grid>
          <Grid container justifyContent="center" mt={2} mb={-1}>
            <Grid item>
              <Grid container spacing={2} justifyContent="center" alignItems="center">
                <Grid item>
                  <Button
                    size="small"
                    type="cancel"
                    variant="contained"
                    sx={{
                      backgroundColor: '#ffffff',
                      '&:hover': { backgroundColor: '#ffffff' },
                      color: '#00043C',
                      border: '1px solid black',
                    }}
                    onClick={handleCancel}
                  >
                    Cancel
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    size="small"
                    type="submit"
                    variant="contained"
                    sx={{
                      backgroundColor: '#00043C',
                      '&:hover': { backgroundColor: '#00043C' },
                      color: '#ffffff',
                    }}
                    onClick={handleAddCustomRule}
                  >
                    Save
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </div>
  );
}
